import type { DeliveryDates, FullPrice } from "@expert/types";

export const getDeliveryDatesFromPrice = (price: FullPrice): DeliveryDates => {
    const minDays = price?.minOnlineDelivery;
    const maxDays = price?.maxOnlineDelivery;
    const minDelivery = new Date(Date.now() + minDays * 24 * 60 * 60 * 1000);
    const maxDelivery = new Date(Date.now() + maxDays * 24 * 60 * 60 * 1000);

    const dateFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    } as Intl.DateTimeFormatOptions;

    return {
        minDate: minDelivery.toLocaleDateString('de-DE', dateFormatOptions),
        maxDate: maxDelivery.toLocaleDateString('de-DE', dateFormatOptions),
    }
}
